import { motion } from "framer-motion";
import OptionsCard from "./OptionsCard";
import BackButtonHeaderPopUp from "../common/BackButtonHeader";

interface OptionsPanelProps {
  options: string[];
  setShowPopUp: React.Dispatch<React.SetStateAction<boolean>>;
  setOptions: React.Dispatch<React.SetStateAction<string>>;
}

/**
 * Definition of the variants of this component
 */
const variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: {
    opacity: 0,
    transition: { duration: 0.1, ease: "easeOut" },
  },
};

const OptionsPanel: React.FC<OptionsPanelProps> = ({
  options,
  setShowPopUp,
  setOptions,
}) => {
  // Handling the selected level
  const handleClickOnOptions = (option: string) => {
    return () => {
      // Set the option
      setOptions(option);
      // And close the pop up
      setShowPopUp(false);
    };
  };

  return (
    <>
      <motion.div
        className="fixed inset-0 w-full h-full bg-neutral-500 bg-opacity-40 backdrop-blur-[2px] z-20 flex flex-col flex-grow"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
        onClick={() => setShowPopUp(false)}
      />
      <motion.div
        className="fixed w-[462px] h-fit max-h-[90vh] left-0 right-0 ml-auto mr-auto bottom-4 px-6 pt-6 pb-8 bg-white rounded-3xl flex-col justify-start items-start gap-6 inline-flex z-30"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
      >
        <div className="self-stretch justify-between items-center inline-flex">
          <div className="justify-start items-center gap-3 flex">
            <BackButtonHeaderPopUp onClick={() => setShowPopUp(false)} />
            <div className="text-neutral-600 text-lg font-normal font-sans leading-snug">
              Pick an option
            </div>
          </div>
        </div>
        <div className="w-full flex-col justify-start items-start gap-4 inline-flex">
          {options.map((option: string, index: number) => (
            <OptionsCard
              key={index}
              option={option}
              handleOnClick={handleClickOnOptions(option)}
            />
          ))}
        </div>
      </motion.div>
    </>
  );
};

export default OptionsPanel;
